// extracted by mini-css-extract-plugin
export var changeIcon = "_77-4";
export var container = "_77-0";
export var divider = "_77-7";
export var externalLinkIcon = "_77-1";
export var green = "_77-5";
export var helpCircleIcon = "_77-3";
export var iconButton = "_77-2";
export var red = "_77-6";